// utils/storageTest.js
// Manual testing script for storage system
// Phase 2.6: Disabled - System B removed, testing will be restored in Phase 3

// Phase 2.6: System B removed - boot and useCollections no longer exist
// import { boot, getBootDiagnostics } from '../app/boot/useBoot.js';
// import { useCollections } from '../data/useCollections.js';
import { createEquipmentItem, createProcedureTemplate, COLLECTIONS } from '../types/core.js';

/**
 * Run comprehensive storage tests
 * Phase 2.6: DISABLED - System B removed (boot and useCollections deleted)
 */
export async function runStorageTests(vesselId = 'test-vessel') {
  console.warn('storageTest: runStorageTests disabled during Phase 2.6 - System B removed');
  return {
    success: false,
    error: 'Storage tests disabled during IndexedDB migration (Phase 2.6)',
    message: 'Tests will be restored in Phase 3 with Dexie system'
  };

  /* Phase 2.6: Commented out - boot() deleted
  try {
    // Test 1: Boot sequence

    const bootResult = await boot(vesselId, { logProgress: true });

    // Test 2: Basic CRUD operations

    const collections = useCollections(vesselId);
    
    // Create equipment item
    const equipment = createEquipmentItem({
      name: 'Test Fire Extinguisher',
      class: 'FFE',
      serial: 'TEST-001',
      location: 'Main Deck'
    });
    
    const savedEquipment = await collections.upsert(COLLECTIONS.EQUIPMENT, equipment);

    // Create procedure
    const procedure = createProcedureTemplate({
      title: 'Test Emergency Procedure',
      steps: ['Step 1: Assess situation', 'Step 2: Take action'],
      category: 'Emergency'
    });
    
    const savedProcedure = await collections.upsert(COLLECTIONS.PROCEDURES, procedure);

    // Test 3: List operations

    const equipmentList = await collections.list(COLLECTIONS.EQUIPMENT);
    const procedureList = await collections.list(COLLECTIONS.PROCEDURES);


    // Test 4: Get operation

    const retrievedEquipment = await collections.get(COLLECTIONS.EQUIPMENT, savedEquipment.id);

    // Test 5: Update operation

    const updatedEquipment = await collections.upsert(COLLECTIONS.EQUIPMENT, {
      ...savedEquipment,
      location: 'Updated Location',
      notes: ['Updated during test']
    });

    // Test 6: Count operation



    try {
      const equipmentCount = await collections.count(COLLECTIONS.EQUIPMENT);

    } catch (error) {


      throw error;
    }
    
    // Test 7: Operations queue

    const opsQueue = await collections.list(COLLECTIONS.OPS_QUEUE);


    return {
      success: true,
      testsRun: 7,
      vesselId,
      timestamp: Date.now()
    };
    
  } catch (error) {

    throw error;
  }
  */
}

/**
 * Quick smoke test
 * Phase 2.6: DISABLED - System B removed
 */
export async function quickTest(vesselId = 'smoke-test') {
  console.warn('storageTest: quickTest disabled during Phase 2.6 - System B removed');
  return false;

  /* Phase 2.6: Commented out - boot() deleted
  try {
    await boot(vesselId);
    const collections = useCollections(vesselId);
    
    const testItem = await collections.upsert(COLLECTIONS.EQUIPMENT, {
      name: 'Smoke Test Item',
      class: 'Test'
    });
    
    const retrieved = await collections.get(COLLECTIONS.EQUIPMENT, testItem.id);
    
    if (retrieved && retrieved.name === 'Smoke Test Item') {

      return true;
    } else {
      throw new Error('Retrieved item does not match');
    }
  } catch (error) {

    return false;
  }
  */
}

/**
 * Diagnostics and debugging
 * Phase 2.6: DISABLED - System B removed
 */
export async function runDiagnostics(vesselId = 'diag-vessel') {
  console.warn('storageTest: runDiagnostics disabled during Phase 2.6 - System B removed');
  return {
    error: 'Diagnostics disabled during IndexedDB migration (Phase 2.6)',
    message: 'Will be restored in Phase 3'
  };

  /* Phase 2.6: Commented out - getBootDiagnostics() deleted
  try {
    const diagnostics = await getBootDiagnostics(vesselId);

    return diagnostics;
  } catch (error) {

    throw error;
  }
  */
}

// Export for browser console testing
// Phase 2.6: Removed boot and useCollections (deleted)
if (typeof window !== 'undefined') {
  window.storageTest = {
    runStorageTests,
    quickTest,
    runDiagnostics
    // Phase 2.6: boot and useCollections removed (functions deleted)
  };
}